import { memo } from 'react';
import { Stack } from '@mui/material';
import { useToggle } from '@dfl/hook-utils';
import { ReactLink } from '@dfl/react-security';
import { useDeleteCarrier } from 'modules/inventory/provider/carriers/hooks/useDeleteCarrier';
import { DeleteRowAction, EditRowActions } from '@dfl/mui-admin-layout';
import { DELETE_PROVIDER_ERRORS } from 'modules/inventory/provider/common/constants/provider-errors';
import { ICarrier } from '../../interfaces';

type CarrierRowActionsProps = {
  carrier: ICarrier;
};

const CarrierRowActions = ({ carrier }: CarrierRowActionsProps) => {
  const { isOpen, onClose, onOpen } = useToggle();
  const { mutate, isPending, error } = useDeleteCarrier(carrier._id || '', onClose);

  return (
    <>
      <Stack direction='row' spacing={1}>
        <ReactLink to={`/inventory/provider/carriers/${carrier._id as string}/general?edit=true`}>
          <EditRowActions />
        </ReactLink>
        <DeleteRowAction
          isOpen={isOpen}
          onOpen={onOpen}
          onClose={onClose}
          error={error}
          isLoading={isPending}
          onDelete={mutate}
          errors={DELETE_PROVIDER_ERRORS}
        />
      </Stack>
    </>
  );
};

export default memo(CarrierRowActions);
